import { DEFAULT_ALIGNMENT, ALIGN_CLASSES_INVERSE, ALIGN_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export function centerable(spec) {
  spec.attrs = Object.assign({}, spec.attrs, {
    alignment: {
      default: DEFAULT_ALIGNMENT
    }
  });
  spec.parseDOM?.forEach(function (rule) {
    let oldGetAttrs = rule.getAttrs;
    rule.getAttrs = dom => {
      let alignment;
      let attrs = {};
      if (oldGetAttrs) {
        Object.assign(attrs, oldGetAttrs(dom));
      }
      dom.classList.forEach(className => {
        if (ALIGN_CLASSES_INVERSE[className]) {
          alignment = ALIGN_CLASSES_INVERSE[className];
        }
      });
      if (alignment) {
        Object.assign(attrs, {
          alignment
        });
      }
      return attrs;
    };
  });
  let oldToDOM = spec.toDOM;
  spec.toDOM = node => {
    if (!oldToDOM) {
      throw new Error('must specify a toDOM method');
    }
    let outputSpec = oldToDOM(node);
    if (outputSpec.length < 2) {
      throw new Error('must specify at least two elements in output spec');
    }
    // ensure we have a top level attrs hash not just a 'hole'
    if (outputSpec[1] === 0) {
      outputSpec.splice(1, 0, {});
    }
    let topLevelAttrs = outputSpec[1];
    if (topLevelAttrs?.class) {
      topLevelAttrs.class += ` ${ALIGN_CLASSES[node.attrs.alignment]}`;
    } else {
      topLevelAttrs.class = ALIGN_CLASSES[node.attrs.alignment];
    }
    return outputSpec;
  };
  return spec;
}